<template>
    <a tabindex="0" id="user-popover" class="header-user-thumbnail" role="button" data-toggle="popover" data-placement="bottom"
        :data-original-title="$page.props.authCheck ? loadSessionUser() : noSessionHeader"
        :data-content="$page.props.authCheck ? loadSessionContent() : noSessionContent">
        <span
            class="flex-center-center"
            v-if="!getIsCambioBookstore"
        >
           <span class="fs-16 mr-2 hidden-mobile" v-if="$page.props.authCheck && getUserName">{{ getUserName | nameFilter }}</span>
           <span class="fs-16 mr-2 hidden-mobile" v-else>Ingresa</span>

           <img :src="getUserPhoto" alt="profile_img" v-if="$page.props.authCheck && getUserPhoto">
           <i class="far fa-user-circle" v-else></i>
        </span>
    </a>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import filtersMixin from '../../../mixins/filtersMixin';

import { checkCatch, showMessage } from '../../../utils';

export default {

    mixins: [
        filtersMixin,
    ],

    data() {

        return {

            noSessionHeader: '<i class="far fa-user-circle fs-40 mr-3"></i> <span class="fs-18">Bienvenido</span>',
            noSessionContent: ` <div class="row fs-16">
                                    <div class="col-12 text-center mb-3">
                                        <span>¿Ya tienes una cuenta?</span>
                                    </div>

                                    <div class="col-12">
                                        <a id="popover-user-login" class="btn btn-block btn-secondary-n flex-between-center fs-20">
                                            Ingresa ahora <i class="fe-arrow-right fs-24"></i>
                                        </a>
                                    </div>

                                    <div class="col-12 text-center my-3">
                                        <span>ó</span>
                                    </div>

                                    <div class="col-12 mb-2">
                                        <a id="popover-user-register" class="btn btn-block btn-primary-n flex-between-center fs-20">
                                            Crea tu cuenta <i class="fe-log-out fs-24"></i>
                                        </a>
                                    </div>
                                </div>`,

        };

    },

    computed: {

        ...mapGetters([

            'getUserName',
            'getUserPhoto',
            'getIsCambioBookstore',

        ]),

    },

    mounted() {

        this.$nextTick(() => {

            this.loadPopover();

        });

    },

    methods: {

        ...mapActions([

            'userLogout',

        ]),

        loadPopover() {

            $('#user-popover').popover({

                container: '#header-options',
                html: true,
                trigger: 'focus',

            });

            $('#user-popover').on('inserted.bs.popover', () => {

                this.$nextTick(() => {

                    $('#popover-user-login').click(() => {

                        this.$inertia.visit(this.route('user.login'));

                    });

                    $('#popover-user-register').click(() => {

                        // $('#user-popover').popover('hide');

                        this.$inertia.visit(this.route('user.register'));

                    });

                    $('#popover-user-notifications').click(() => {

                        // $('#user-popover').popover('hide');

                        this.$inertia.visit(`${this.route('user.account')}?opt=notifications`);

                    });

                    $('#popover-user-my-account').click(() => {

                        // $('#user-popover').popover('hide');

                        this.$inertia.visit(`${this.route('user.account')}?opt=my-account`);

                    });

                    $('#popover-user-my-shopping').click(() => {

                        // $('#user-popover').popover('hide');

                        this.$inertia.visit(`${this.route('user.account')}?opt=my-shopping`);

                    });

                    $('#popover-user-questions').click(() => {

                        // $('#user-popover').popover('hide');

                        this.$inertia.visit(`${this.route('user.account')}?opt=questions`);

                    });

                    $('#popover-user-my-interests').click(() => {

                        // $('#user-popover').popover('hide');

                        this.$inertia.visit(`${this.route('user.account')}?opt=my-interests`);

                    });

                    $('#popover-user-security').click(() => {

                        // $('#user-popover').popover('hide');

                        this.$inertia.visit(`${this.route('user.account')}?opt=security`);

                    });

                    $('#popover-user-logout').click(() => {

                        // $('#user-popover').popover('hide');

                        this.logout();

                    });

                });

            });

        },

        loadSessionUser() {

            let userName = this.getUserName;

            if (!userName) {

                return this.noSessionHeader;

            }

            if (userName.length > 17) {

                userName = `${userName.substring(0, 16)}...`;

            }

            return `${this.getUserPhoto
                ? `<img class="popover-user-thumbnail-img mr-3" src="${this.getUserPhoto}" alt="profile_img">`
                : '<i class="far fa-user-circle fs-40 mr-3"></i>'}
                    <div>
                        <span class="fs-18">${userName}</span>
                        <br>
                        <span class="fs-16 fw-400 color-dark-gray">Bienvenido de nuevo.</span>
                    </div>`;

        },

        loadSessionContent() {

            if (!this.getUserName) {

                return this.noSessionContent;

            }

            return `<div class="row fs-16">
                        <!-- <div id="popover-user-notifications" class="col-12 popover-user-option">
                            <i class="fe-bell mr-2"></i> Notificaciones
                        </div> --!>

                        <div id="popover-user-my-account" class="col-12 popover-user-option">
                            <i class="fe-user mr-2"></i> Mi cuenta y datos personales
                        </div>

                        <div id="popover-user-my-shopping" class="col-12 popover-user-option">
                            <i class="fe-shopping-bag mr-2"></i> Mis compras
                        </div>

                        <!-- <div id="popover-user-questions" class="col-12 popover-user-option">
                            <i class="far fa-question-circle mr-2"></i> Preguntas
                        </div> --!>

                        <div id="popover-user-my-interests" class="col-12 popover-user-option">
                            <i class="fe-heart mr-2"></i> Me interesa
                        </div>

                        <!-- <div id="popover-user-security" class="col-12 popover-user-option">
                            <i class="fe-lock mr-2"></i> Seguridad
                        </div> --!>

                        <div id="popover-user-logout" class="col-12 popover-user-logout flex-between-center">
                            <span>Salir</span>
                            <i class="fe-lock"></i>
                        </div>
                    </div>`;

        },

        logout() {

            axios
                .post('/user/logout')
                .then((response) => {

                    const { data } = response;

                    if (!data.success) {

                        showMessage('error', 'Atención', data.message);

                        return;

                    }

                    this.userLogout();

                    this.$inertia.visit(this.route('home'));

                })
                .catch((error) => {

                    checkCatch(error);

                });

        },

    },

};
</script>
